import { memo, useLayoutEffect, useState } from 'react';
import { Position } from 'reactflow';

import styled from 'styled-components';

import { StyledHandle } from 'ui/journey-builder/node-types/node-container';
import { JourneyNode } from 'ui/journey-builder/node-types/types';

const GhostSourceHandle = styled(StyledHandle).attrs({
  type: 'source',
  id: 'source-handle',
})({
  visibility: 'hidden',
});

const GhostTargetHandle = styled(StyledHandle).attrs({
  type: 'target',
  id: 'target-handle',
})({
  visibility: 'hidden',
});

export const Node = memo((node: JourneyNode) => {
  const [height, setHeight] = useState(0);
  const originalNode = node.id.split('-ghost')[0];
  useLayoutEffect(() => {
    const observer = new ResizeObserver((entries) => {
      setHeight(entries[0].contentRect.height);
    });
    const element = document.querySelector(`[data-id="${originalNode}"]`);
    if (!element) return;
    observer.observe(element);
  }, [originalNode]);
  return (
    <div style={{ visibility: 'hidden', width: 1, height }}>
      <GhostSourceHandle position={node.sourcePosition ?? Position.Bottom} />
      <GhostTargetHandle position={node.targetPosition ?? Position.Top} />
    </div>
  );
});
